import React from 'react';
import ToolLayout from '../../components/ToolLayout';
import ColorConverter from '../../components/ColorConverter';

const ColorConvert: React.FC = () => (
  <ToolLayout
    title="Color Converter - HEX, RGB, HSL | AllTools"
    description="Convert colors between HEX, RGB, and HSL formats. Visual color picker with instant conversion."
    canonicalPath="/color-converter"
  >
    <ColorConverter />
  </ToolLayout>
);

export default ColorConvert;
